import { createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import { blueGrey } from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: blue,
  },
});

export default theme;

export const neutralTheme = createMuiTheme({
  palette: {
    primary: {
      main: blueGrey[700],
    },
    // secondary: {
    //   main: red[700],
    // },
  },
});
